import { useEffect, useContext, useState } from 'react';
import { checkTrailingSpace } from '../../../js/verificationFunctions';
import { userDataCtx } from '../../../hooks/applicationData';
import ClaimInput from '../ClaimInput';
import { laCareAreaMapping } from '../Medbank/medbankData';
import {CareSettingOptionItem, customRegisterValueIitem} from '../../../interfaces/Interfaces';


interface LA_Claims {
    LA_role: string;
    LA_care_setting: string;
    LA_RN_Number: string;
};

const defaultClaimValues = {
   userProvisionStatus: "",
   LA_role: "",
   LA_care_setting:"",
   LA_RN_Number:""
};

const care_settings_options = [
    {name: "All Nursing/Patient Care", className:"", value:"All Nursing"},
    {name: "All Pharmacy", className:"", value:"All Pharmacy"},
    {name: "All Allied Health", className:"", value:"All Allied Health"},
    {name: "All Biomed/Material Management", className:"", value:"All Biomed-Material Management"},
    {name: "All Physician/APP", className:"", value:"All Physician"}
]

// These job categories (aka: care settings) should be added back when Phase 2 of Learning Academy launches
// {name: "Laboratory", className:"", value:"Laboratory"},
// {name: "Ancillary/Other", className:"", value:"Ancillary/Other"}

const role_options = [
    {name: "No", className:"", value:"Learner"},
    {name: "Yes", className:"", value:"Learner Manager"}
];

function ValidateLAClaims(data: any): [boolean, Map<string, boolean>] {
    let validationFlags = new Map<string, boolean>([
      ['roleNeededError', false],
      ['jobCategoryNeededError', false],
    ]);
  
    //@ts-ignore
    const claims: LA_Claims = data;
  
    const stringNotEmpty = (str: string) =>
      str !== undefined && str !== null && str !== '';
  
    let validRole = stringNotEmpty(claims.LA_role);
    if (!validRole) validationFlags.set('roleNeededError', true);
    let validCareSetting = stringNotEmpty(claims.LA_care_setting);
    if (!validCareSetting) validationFlags.set('jobCategoryNeededError', true);
    return [validRole && validCareSetting, validationFlags];
  };

//TODO Add translations
function EditLAClaims(props: any) {
    const CONFIG = require('../../../config.json')[process.env.NODE_ENV];
    const [selectedRole, setSelectedRole] = useState('');
    const [LACareSettingOptions, setLACareSettingOptions] = useState<Array<CareSettingOptionItem>>();

    const {data, setData:setClaim, validationFlags} = useContext(userDataCtx);
    //@ts-ignore
    const claims: LA_Claims = data;
    const getClaim = (name: string)=>{
        const stateClaim = claims[name as keyof LA_Claims];
        if(stateClaim) return stateClaim;
        //@ts-ignore
        return defaultClaimValues[name];
    }
    const setRNNumber = (number: string) => {
        setClaim("LA_RN_Number", number);
    }
   //const localUserType = $('#regitration-steps-container').data('user-type');
    useEffect(() => {
        if (props.userType === 'independent') {
            setClaim('LA_role', 'Learner');
        }
    }, [props.userType]);
    
    useEffect(() => {
        if (
            props.appId === CONFIG.learningAcademy ||
            props.appId === CONFIG.learningAcademyLevel2
        ) {
            if (getClaim('LA_role') !== 'Learner') {
                setClaim('LA_role', 'Learner');
            }
            if (selectedRole !== 'Learner') {
                setSelectedRole('Learner');
            }
        } else if (props.appId === CONFIG.learningAcademyLevel3) {
            if (getClaim('LA_role') !== 'Learner Manager') {
                setClaim('LA_role', 'Learner Manager');
            }
            if (selectedRole !== 'Learner Manager') {
                setSelectedRole('Learner Manager');
            }
        }
        // //set default care seting options first and then evaluate it
        setLACareSettingOptions(care_settings_options);
        if (props.customRegistrationValues && props.customRegistrationValues.length > 0) {
            var LACareOptions = props.customRegistrationValues.filter((d: customRegisterValueIitem) => d.fieldName == "LA_care_setting_select");
            if (LACareOptions != undefined && LACareOptions.length > 0) {
                setLACareSettingOptions(LACareOptions[0].values);
            }
        }

    }, [props.appId, CONFIG, selectedRole]);
      
    const isCareSettingSelected = getClaim("LA_care_setting") !== ""
    if (props.userType === 'student') {
        return <></>
    } else {
        return <>
            <div className="row" style={{display: 'flex', alignItems: 'flex-end' }}>            
                {props.userType !== "independent" ?
                    <div className="hide">
                        {validationFlags.has("roleNeededError") && validationFlags.get("roleNeededError") && <p className="accent-1-text">
                        <i className="fa fa-exclamation-circle" aria-hidden="true"></i>
                            &nbsp;<span className="">Please select if you need to manage users.</span>
                            </p>}
                        <label className="LA_Role_Select" htmlFor="LA_Role_Select">Will you manage and assign courses for other facility users?</label>
                        <select
                            id="LA_Role_Select"
                            value={getClaim("LA_role")}
                            onChange={e => setClaim("LA_role", e.target.value)}
                            className={validationFlags.has("roleNeededError") && validationFlags.get("roleNeededError") ? "error" : ""}>
                            {/* <option disabled hidden value="" className="">Select</option> */}
                            {role_options.map(
                                role => <option 
                                        data-testid={role.value}
                                        key={role.value}
                                        className={role.className}
                                        value={role.value}>
                                    {role.name}
                                </option>
                            )}
                            </select>
                    </div> : <></>}
                <div className="col-sm-6">              
                    {validationFlags.has("jobCategoryNeededError") && validationFlags.get("jobCategoryNeededError") && <p className="accent-1-text">
                    <i className="fa fa-exclamation-circle" aria-hidden="true"></i>
                        &nbsp;<span className="">Please select the subject that interests you most.</span>
                        </p>}          
                    <label htmlFor="LA_care_setting_select" className="LA_care_setting_select 1f8ef871-3106-412c-a7d8-6b9962a9c2fb">What learning content are you most interested in reviewing?</label>
                    <select
                        id="LA_care_setting_select"
                        value={getClaim("LA_care_setting")}
                        onChange={e => setClaim("LA_care_setting", e.target.value)}
                        className={validationFlags.has("jobCategoryNeededError") && validationFlags.get("jobCategoryNeededError") ? "error" : ""}>
                        <option disabled hidden value="" className="69be1eee-6f1d-46e3-b2e4-1fddd7076852">
                            Select a subject
                        </option>
                        {LACareSettingOptions && LACareSettingOptions?.length > 0 && LACareSettingOptions.map(role => <option
                                key={role.value}
                                className={role.className}
                                value={role.value}>
                                {role.name}
                            </option>
                        )}
                    </select>
                </div>
            </div>
            <div className="row" data-testid="LearningAcademy" >
                <div className="hide">
                    <label className="rn_number" htmlFor="rn_number">License Number - Optional</label>
                    <ClaimInput
                        placeholder='License Number'
                        className=''
                        id='rn_number'
                        value={getClaim("LA_RN_Number")}
                        onChange={(e) => setRNNumber(e.target.value)}
                    />
                </div>
            </div>
        </>;
    }
}

function ReviewLAClaims(props: any) {
    const {data} = useContext(userDataCtx);
    //@ts-ignore
    const claims: LA_Claims = data; 
    const display_care_settings = care_settings_options.find(
        (cs) => cs.value === claims.LA_care_setting
    );
    const display_role = role_options.find(
        role => role.value === claims.LA_role
    );

    const getClaim = (name: string)=>{
        const stateClaim = claims[name as keyof LA_Claims];
        if(stateClaim) return stateClaim;
        //@ts-ignore
        return defaultClaimValues[name];
    }

    if (props.userType === "student") {
        return <></>
    } else {
        return<>
            <h2> {ShowLAName(props.userType)} </h2>
            <div className="row" style={{display: 'flex', alignItems: 'flex-end' }}>
                <div className="hide">
                    <p>
                        <span> <div className="LA_Role_Select">Will you manage and assign courses for other facility users?</div>:</span> 
                        <div className={display_role?.className}>
                            {getClaim("LA_role")}
                        </div>
                    </p>
                </div>
                <div className="hide">
                    <p>
                        <span> <div className="rn_number">License Number</div>: </span><div>{claims.LA_RN_Number}</div>
                    </p>
                </div>
            </div>
            <div className='row'>
                <div className="col-sm-6">
                    <p>
                        <span> <div className="LA_care_setting_select 1f8ef871-3106-412c-a7d8-6b9962a9c2fb">What learning content are you most interested in reviewing?</div>:</span> 
                        <div className={display_care_settings?.className}>
                            {getClaim("LA_care_setting")}
                        </div>
                    </p>
                </div>
            </div>
        </>;
    }
}

function ShowLAName(props: any){
    //const localUserType = $('#regitration-steps-container').data('user-type');
    if (props.userType === 'student') {
        return null;
    } else {
        return <span className="">
        BD Learning Academy
    </span>
    }
}
export { EditLAClaims, ReviewLAClaims, ShowLAName, ValidateLAClaims };
